// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: #64748b;
}

.page-loader--full {
  min-height: 280px;
  padding: 48px 24px;
}

.page-loader--inline {
  flex-direction: row;
  gap: 12px;
  padding: 32px 16px;
  min-height: auto;
}

.page-loader--overlay {
  min-height: 200px;
  padding: 40px;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 12px;
}

.page-loader-spinner {
  position: relative;
  width: 44px;
  height: 44px;
}

.page-loader-ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 3px solid #e5e7eb;
  border-top-color: #f97316;
  animation: page-loader-spin 0.85s linear infinite;
}

.page-loader-ring--inner {
  inset: 7px;
  border-width: 2px;
  border-top-color: #174078;
  animation-duration: 1.1s;
  animation-direction: reverse;
}

.page-loader-message {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  letter-spacing: 0.01em;
}

.page-loader--inline .page-loader-spinner {
  width: 28px;
  height: 28px;
}

.page-loader--inline .page-loader-ring--inner {
  inset: 5px;
}

.page-loader--inline .page-loader-message {
  font-size: 13px;
}

@keyframes page-loader-spin {
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/compoonents/PageLoader/PageLoader.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,iDAAiD;AACnD;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".page-loader {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  color: #64748b;\n}\n\n.page-loader--full {\n  min-height: 280px;\n  padding: 48px 24px;\n}\n\n.page-loader--inline {\n  flex-direction: row;\n  gap: 12px;\n  padding: 32px 16px;\n  min-height: auto;\n}\n\n.page-loader--overlay {\n  min-height: 200px;\n  padding: 40px;\n  background: rgba(255, 255, 255, 0.85);\n  border-radius: 12px;\n}\n\n.page-loader-spinner {\n  position: relative;\n  width: 44px;\n  height: 44px;\n}\n\n.page-loader-ring {\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  border: 3px solid #e5e7eb;\n  border-top-color: #f97316;\n  animation: page-loader-spin 0.85s linear infinite;\n}\n\n.page-loader-ring--inner {\n  inset: 7px;\n  border-width: 2px;\n  border-top-color: #174078;\n  animation-duration: 1.1s;\n  animation-direction: reverse;\n}\n\n.page-loader-message {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b;\n  letter-spacing: 0.01em;\n}\n\n.page-loader--inline .page-loader-spinner {\n  width: 28px;\n  height: 28px;\n}\n\n.page-loader--inline .page-loader-ring--inner {\n  inset: 5px;\n}\n\n.page-loader--inline .page-loader-message {\n  font-size: 13px;\n}\n\n@keyframes page-loader-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
